<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid>
			<b-row class="mt-3 mb-2">
				<b-col class="col-md-6 col-sm-6 col-xs-6">
					<h3>Download Device Report</h3>
				</b-col>
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
					<b-button variant="dark" pill class="mr-2" @click="showDeviceReportModal()">Choose Device</b-button>
				</b-col>
			</b-row>
		</b-container>
		<b-container fluid>
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
					<div style="border-top: 3px solid #333; border-radius: 5px; min-height: 100px; background-color: #FFF; display: flex; flex-direction: column;">
						<b-row class="mt-4 px-3 mb-3">
							<b-col lg="6">
								<label class="mr-2">Show</label>
								<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
								</b-form-select>
								<span class="ml-2">entries</span>
							</b-col>
							<b-col lg="4" offset-md="2" class="text-right">
								<b-button variant="dark" pill class="mr-2" @click="downloadPDF()">Download PDF</b-button>
							</b-col>
						</b-row>
						<b-row class="px-3">
							<b-col lg="12">
								<b-table show-empty sticky-header small striped outlined stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
									<template v-slot:cell(output_status)="row">
										<b-badge pill variant="success" v-if="row.value == 1">ON</b-badge>
										<b-badge pill variant="danger" v-else>OFF</b-badge>
									</template>
									<template v-slot:cell(supply)="row">
										<img src="../assets/power-on.svg" v-if="row.value == 'ON'" style="max-width:20px; max-height:20px;">
										<img src="../assets/power-off.svg" v-else style="max-width:20px; max-height:20px;">
									</template>
									<template v-slot:cell(door_status)="row">
										<b-badge pill variant="danger" v-if="row.value == 1">OPENED</b-badge>
										<b-badge pill variant="success" v-else>CLOSED</b-badge>
									</template>
								</b-table>
							</b-col>
						</b-row>
						<b-row class="px-3 mb-3">
							<b-col lg="6">
								<span class="mr-2">Showing {{(currentPage-1)*perPage}} to {{currentPage*perPage}} of {{records.length}} entries</span>
							</b-col>
							<b-col lg="6">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>

            <b-modal id="my-model" title="Choose device" ok-only @hidden="resetSelectedItem" @ok="modalSubmit">
				<form ref="form" @submit.stop.prevent="handleSubmit">
                    <b-form-group label="IMEI NO" label-cols="3" label-size="sm" label-align-sm="right">
                        <b-form-input v-model="selectedItem.imei_no" required maxlength="30"></b-form-input>
                    </b-form-group>
                    <b-form-group label-cols="3" label-size="sm" label-align-sm="right">
                        <p class="text-center py-0 my-0">- OR -</p>
                    </b-form-group>
                    <b-form-group label="Feeder Pillar No" label-cols="3" label-size="sm" label-align-sm="right">
                        <b-form-input v-model="selectedItem.feeder_pillar_no" required maxlength="30"></b-form-input>
                    </b-form-group>
                    <b-form-group label="Start Date" label-cols="3" label-size="sm" label-align-sm="right">
						<b-form-datepicker v-model="selectedItem.start_date" :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }" :hide-header="true"></b-form-datepicker>
					</b-form-group>
					<b-form-group label="End Date" label-cols="3" label-size="sm" label-align-sm="right">
						<b-form-datepicker v-model="selectedItem.end_date" :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }" :hide-header="true"></b-form-datepicker>
					</b-form-group>
				</form>
				<template v-slot:modal-footer="{ ok, close }">
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
					<b-button size="sm" variant="success" @click="ok()">Submit</b-button>
				</template>
			</b-modal>
            
		</b-container>
        <transition name="fade">
			<b-row v-if="loading" class="loading" style="position: fixed; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
	</div>
</template>
<script>
import Header from "@/components/Header.vue";
export default {
	name: 'Devices',
	components: {
		"top-header": Header
	},
	mounted(){
	},
	data() {
		var self = this;
		return{
			email: '',
			password: '',
            loading: false,
			url: self.$session.get('apiurl')+'api/device-report',
			imeino: self.$route.params.imeino,
			location: '',
			filterselected: '',
			records: [],
			device: {},
			fields: [
				{ key: 'supply', label: 'Power', sortable: true, sortDirection: 'desc' },
				{ key: 'voltage_r', label: 'Volt.R' ,
					formatter: (value, key, item) => { 
						if(self.device.meter_type === '1P'){
							return (value).toFixed(1);
						}
						if(item.output_status == 0 && parseInt(value/100) < self.$root.correction_volt){
							value = 0;
						}
						if(parseInt(value/100) <= 80){
							value = 0;
						}
						return (value/100).toFixed(1);
					},
				},
				{ key: 'voltage_y', label: 'Volt.Y' ,
					formatter: (value, key, item) => { 
						if(item.meter_phase_type === '1' || item.meter_phase_type === 1){
							return (value/10).toFixed(1);
						}
						if(parseInt(value/100) < self.$root.correction_volt){
							value = 0;
						}
						return (value/100).toFixed(1);
					},
				},
				{ key: 'voltage_b', label: 'Volt.B',
					formatter: (value, key, item) => { 
						if(item.meter_phase_type === '1' || item.meter_phase_type === 1){
							return (value/10).toFixed(1);
						}
						if(parseInt(value/100) < self.$root.correction_volt){
							value = 0;
						}
						return (value/100).toFixed(1);
					},
				},
				{ key: 'amp_r', label: 'Amp.R' ,
					formatter: (value, key, item) => { 
						if(item.meter_phase_type === '1' || item.meter_phase_type === 1){
							return (value/100).toFixed(2);
						}
						if(item.output_status == 0 && parseInt(value/1000) < self.$root.correction_amp){
							value = 0;
						}
						if(parseInt(item.voltage_r/100) <= 80){
							value = 0;
						}
						return (value/1000).toFixed(1);
					},
				},
				{ key: 'amp_y', label: 'Amp.Y' ,
					formatter: (value, key, item) => { 
						if(item.meter_phase_type === '1' || item.meter_phase_type === 1){
							return (value/100).toFixed(2);
						}
						if(item.output_status == 0 && parseInt(value/1000) < self.$root.correction_amp){
							value = 0;
						}
						if(parseInt(item.voltage_y/100) <= 80){
							value = 0;
						}
						return (value/1000).toFixed(1);
					},
				},
				{ key: 'amp_b', label: 'Amp.B' ,
					formatter: (value, key, item) => { 
						if(item.meter_phase_type === '1' || item.meter_phase_type === 1){
							return (value/100).toFixed(2);
						}
						if(item.output_status == 0 && parseInt(value/1000) < self.$root.correction_amp){
							value = 0;
						}
						if(parseInt(item.voltage_b/100) <= 80){
							value = 0;
						}
						return (value/1000).toFixed(1);
					},
				},
				{ key: 'kw_r', label: 'KwR',
					formatter: (value, key, item) => { 
						if(item.meter_phase_type === '1' || item.meter_phase_type === 1){
							return (value/1000).toFixed(3);
						}

						if(item.output_status == 0 && (parseInt(item.amp_r/1000) < self.$root.correction_amp)){
							value = 0;
						}
						if(parseInt(item.voltage_r/100) <= 80){
							value = 0;
						}
						return (value/100000).toFixed(2);
					},
				},
				{ key: 'kw_y', label: 'KwY',
					formatter: (value, key, item) => { 
						if(item.meter_phase_type === '1' || item.meter_phase_type === 1){
							return (value/1000).toFixed(3);
						}

						if(item.output_status == 0 && (parseInt(item.amp_y/1000) < self.$root.correction_amp)){
							value = 0;
						}
						if(parseInt(item.voltage_y/100) <= 80){
							value = 0;
						}
						return (value/100000).toFixed(2);
					},
				},
				{ key: 'kw_b', label: 'KwB',
					formatter: (value, key, item) => { 
						if(item.meter_phase_type === '1' || item.meter_phase_type === 1){
							return (value/1000).toFixed(3);
						}

						if(item.output_status == 0 && (parseInt(item.amp_b/1000) < self.$root.correction_amp)){
							value = 0;
						}
						if(parseInt(item.voltage_b/100) <= 80){
							value = 0;
						}
						return (value/100000).toFixed(2);
					},
				},
				{ key: 'kwh', label: 'Kwh',
					formatter: (value) => { 
						if(self.device.meter_type === '1P'){
							return value.toFixed(2);
						}
						return (value/100).toFixed(2);
					},
				},
				{ key: 'total_kw', label: 'Total KW',
					formatter: (value, key, item) => { 
						if(self.device.meter_type === '1P'){
							return (item.total_kw).toFixed(2);
						}
						if(item.output_status == 0 && (parseInt(item.amp_r/1000) < self.$root.correction_amp && parseInt(item.amp_y/1000) < self.$root.correction_amp && parseInt(item.amp_b/1000) < self.$root.correction_amp)){
							value = 0;
						}
						return (value/100000).toFixed(2);
					},
				},
				{ key: 'update_time', label: 'TimeStamp',
					formatter: (value, key, item) => {
						var self = this;
						return self.$moment(item.update_time).format('DD-MM-YYYY HH:mm:ss');
					}, 
				},
				{ key: 'output_status', label: 'output', sortable: true },
				{ key: 'door_status', label: 'Door', sortable: true }
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
            selectedItem: {},
			emptyItem: {
				id: 0,
                imei_no: '',
                feeder_pillar_no: '',
				start_date: '',
                end_date: ''
			}
		};
	},
	methods: {
        showDeviceReportModal() {
            this.selectedItem = Object.assign({}, this.emptyItem);
			this.$root.$emit('bv::show::modal', 'my-model');
		},
        resetSelectedItem(){
			var self = this;
			self.selectedItem = Object.assign({}, self.emptyItem);
		},
		downloadPDF(){
			var self = this;

			var pdfMake = require('pdfmake/build/pdfmake.js');
			var pdfFonts = require('pdfmake/build/vfs_fonts.js');
			pdfMake.vfs = pdfFonts.pdfMake.vfs;

			var pdfdata = new Array();
			var data = new Array();
			self.fields.forEach(element => {
				data.push(element.label);
			});
			pdfdata.push(data);
			for(var i=0; i<self.records.length; i++){
				data = new Array();

				var output_status = self.records[i]['output_status'];
				var amp_r = self.records[i]['amp_r'];
				var amp_y = self.records[i]['amp_y'];
				var amp_b = self.records[i]['amp_b'];
				var kw_r = self.records[i]['kw_r'];
				self.fields.forEach(element => {
					var value = self.records[i][element.key];

					if(self.device.meter_type == '1P'){
						if(element.key == 'voltage_r' || element.key == 'voltage_y' || element.key == 'voltage_b'){
							value = value.toFixed(1);
						}
						if(element.key == 'amp_r' || element.key == 'amp_y' || element.key == 'amp_b'){
							value = (value/100).toFixed(2);
						}
						if(element.key == 'kw_r' || element.key == 'kw_y' || element.key == 'kw_b'){
							value = (value/1000).toFixed(3);
						}
						if(element.key == 'total_kw'){
							value = (kw_r/1000).toFixed(3);
						}
					}else{
						if(element.key == 'voltage_r' || element.key == 'voltage_y' || element.key == 'voltage_b'){
							if(output_status == 0 && parseInt(value/100) < self.$root.correction_volt){
								value = 0;
							}
							value = (value/100).toFixed(1);
						}
						if(element.key == 'amp_r' || element.key == 'amp_y' || element.key == 'amp_b'){
							if(output_status == 0 && parseInt(value/1000) < self.$root.correction_amp){
								value = 0;
							}
							value = (value/1000).toFixed(1);
						}
						if(element.key == 'kw_r' || element.key == 'kw_y' || element.key == 'kw_b'){
							if(output_status == 0 && parseInt(value/100000) < self.$root.correction_amp){
								value = 0;
							}
							value = (value/100000).toFixed(2);
						}
						if(element.key == 'total_kw'){
							if(output_status == 0 && (parseInt(amp_r/1000) < self.$root.correction_amp && parseInt(amp_y/1000) < self.$root.correction_amp && parseInt(amp_b/1000) < self.$root.correction_amp)){
								value = 0;
							}
							value = (value/100000).toFixed(2);
						}
					}

					if(element.key == 'kwh'){
						value = (value/100).toFixed(2);
					}

					if(element.key == 'output_status'){
						if(value ==1){
							value = "ON";
						}else{
							value = "OFF";
						}
					}

					if(element.key == 'door_status'){
						if(value ==1){
							value = "OPEN";
						}else{
							value = "CLOSED";
						}
					}



					data.push(value);
				});
				pdfdata.push(data);
			}
			var deviceid = ''
			if(this.filterselected.feeder_pillar_no != ""){
				deviceid = this.filterselected.feeder_pillar_no;
			}else{
				deviceid = this.filterselected.imei_no;
			}

			var d = new Date();
			var uniq = d.getFullYear()+'-'+d.getMonth()+'-'+d.getDate()+'-'+d.getTime();
			var docDefinition = {
				content: [
					{ text: 'Device Report : '+deviceid, style: 'heading' },
                    { text: 'From: '+self.filterselected.start_date+' 00:00:00 To: '+self.filterselected.end_date+' 23:59:59', style: 'subheading' },
					{
						layout: 'lightHorizontalLines',
						table: {
							headerRows: 1,

							body: pdfdata
						}
					}
				],
				styles: {
					heading: {
						fontSize: 20,
						alignment: 'center',
						lineHeight: 1,
						bold: true
					},
                    subheading: {
                        fontSize: 14,
						alignment: 'center',
						lineHeight: 2,
						bold: false
                    }
				},
				defaultStyle: {
					fontSize: 10,
					bold: false
				},
				pageOrientation: 'landscape',
			};
			pdfMake.createPdf(docDefinition).download("REPORT_"+uniq+".pdf");
		},
        modalSubmit(bvModalEvt){
			var self = this;
			
			self.loading = true;
			bvModalEvt.preventDefault();

			self.filterselected = self.selectedItem;
            
			self.axios.post(self.url, {
				accesskey: self.$session.get('access_key'),
				data: self.selectedItem
			})
			.then(function (response) {
                self.loading = false;
				if(response.data.error == 0 || response.data.error == '0'){
                    var tmparr = response.data.result.records;
                    

					tmparr.forEach(function(field){
						if(field.datalength == 59){
							field.supply = 'OFF';
						}else{
							field.supply = "ON";
						}

						

						/*if(field.meter_type === '1P'){
							field.voltage_r = (field.voltage_r/10).toFixed(2);
							field.voltage_y = (field.voltage_y/10).toFixed(2);
							field.voltage_b = (field.voltage_b/10).toFixed(2);

							field.amp_r = (field.amp_r/100).toFixed(2);
						}else{
							if(parseInt(field.voltage_r/100) <= 80){
								field.voltage_r = 0;
							}else{
								field.voltage_r = (field.voltage_r/100).toFixed(2);
							}
							if(parseInt(field.voltage_y/100) <= 80){
								field.voltage_y = 0;
							}else{
								field.voltage_y = (field.voltage_y/100).toFixed(2);
							}
							if(parseInt(field.voltage_b/100) <= 80){
								field.voltage_b = 0;
							}else{
								field.voltage_b = (field.voltage_b/100).toFixed(2);
							}

							if(field.voltage_r == 0 || (field.output_status == 0 && parseInt(field.amp_r/1000) < self.$root.correction_amp)){
								field.amp_r = 0;
							}else{
								field.amp_r = (field.amp_r/1000).toFixed(1);
							}
						}
*/
						
						

					});
					self.records = tmparr;

					self.totalRows = self.records.length;

                    self.$bvModal.hide('my-model');
                    self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		onFiltered(filteredItems) {
			// Trigger pagination to update the number of buttons/pages due to filtering
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		downloadcsv(){
			var self = this;
			var header = new Array()
			self.fields.forEach(function(item){
				if(!item.extra){
					header.push(item.label);
				}
			});
			
			//var d = table.rows().data();
			var finalarr = new Array();
			finalarr.push(header);
			self.records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
			
			let csvContent = "data:text/csv;charset=utf-8," 
			+ finalarr.map(e => e.join(",")).join("\n");

			var encodedUri = encodeURI(csvContent);
			var link = document.createElement("a");
			link.setAttribute("href", encodedUri);
			link.setAttribute("download", "device_data_report.csv");
			document.body.appendChild(link); // Required for FF

			link.click();
		}
	}
}
</script>
<style>
html{
	min-height: 100%;
}
body{
	background-color: '#FFF' !important;
	background-image: none !important;
}
.table{
	font-size: small;
}
.table td, .table th{
	vertical-align: middle;
}
</style>